module.exports = __webpack_public_path__ + "img/search-document.860bf2a6.svg";